<template>
    <div>
        <div class="container-fluid">
            <div class="container align-middle">
                <div class="row">
                    <div class="col-12">
                        <h2 class="h2desctop desktop-vers">Результаты наших учеников</h2>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid lessons-how greenback">
            <div class="container align-middle">
                <div class="row mobile-vers">
                    <div class="col-12">
                        <h2 class="h2desctop">Результаты наших учеников</h2>
                    </div>
                </div>
                <div class="row desktop-vers">
                    <div class="col-12 col-sm-5 fotokind">
                        <img src="@/assets/hometeacher/images/skorochtenie/olimpiya.png" alt="Олимпия">
                    </div>
                    <div class="col-12 col-sm-7 textresult">
                        <div class="nameresult">Олимпия (7 лет)</div>
                        <p>Поздравляем Олимпию (7 лет) с успешным окончанием курса # скорочтение для школьников! За 4,5
                            месяца, а это 36 академических часов, Олимпия показала потрясающие результаты – с 75 слов в
                            минуту скорость чтения достигла 250 слов в минуту при 100% усвоении текста!!!!!</p>

                        <div class="row">
                            <div class="col-12">
                                <div class="center-delimeter-green"></div>
                            </div>
                        </div>

                        <table style="width:100%; border:none;">
                            <tbody>
                            <tr>
                                <td>
                                    <div class="shapka"></div>
                                    <div class="stalo">Стало <img
                                            src="@/assets/hometeacher/images/skorochtenie/stalo.png"></div>
                                    <div class="bilo">Было <img src="@/assets/hometeacher/images/skorochtenie/bilo.png">
                                    </div>
                                </td>
                                <td>
                                    <div class="shapka">Скорочтение</div>
                                    <div class="stalo">120 слов/мин</div>
                                    <div class="bilo">50 слов/мин</div>
                                </td>
                                <td>
                                    <div class="shapka">Память</div>
                                    <div class="stalo">28/30 картинок</div>
                                    <div class="bilo">4/10 картинок</div>
                                </td>
                                <td>
                                    <div class="shapka">Мышление</div>
                                    <div class="stalo">6/6 задач</div>
                                    <div class="bilo">4/6 задач</div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="row mobile-vers kray">
                    <div class="col-12 fotokind">
                        <img src="@/assets/hometeacher/images/skorochtenie/olimpiya-mobile.jpg" alt="Олимпия">
                    </div>
                </div>
                <div class="row mobile-vers">
                    <div class="col-12">
                        <div class="nameresult">Олимпия (7 лет)</div>
                        <div class="shapka">Скорочтение</div>
                        <div class="stalo"><span class="fz16px">Стало:</span> 120 слов/мин</div>
                        <div class="bilo"><span class="fz16px">Было:</span> 50 слов/мин</div>
                        <div class="row">
                            <div class="col-12">
                                <div class="center-delimeter-green"></div>
                            </div>
                        </div>
                        <div class="shapka">Память</div>
                        <div class="stalo"><span class="fz16px">Стало:</span> 28/30 картинок</div>
                        <div class="bilo"><span class="fz16px">Было:</span> 4/10 картинок</div>
                        <div class="row">
                            <div class="col-12">
                                <div class="center-delimeter-green"></div>
                            </div>
                        </div>
                        <div class="shapka">Мышление</div>
                        <div class="stalo"><span class="fz16px">Стало:</span> 6/6 задач</div>
                        <div class="bilo"><span class="fz16px">Было:</span> 4/6 задач</div>
                        <div class="row">
                            <div class="col-12">
                                <div class="center-delimeter-green"></div>
                            </div>
                        </div>
                        <p>Поздравляем Олимпию (7 лет) с успешным окончанием курса # скорочтение для школьников! За 4,5
                            месяца, а это 36 академических часов, Олимпия показала потрясающие результаты – с 75 слов в
                            минуту скорость чтения достигла 250 слов в минуту при 100% усвоении текста!!!!!</p>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CourseSkorochtenieResult',
    }
</script>

<style scoped>
    .mobile-vers {
        display: none;
    }

    .greenback {
        background: #5ab947;
        margin-bottom: -16px;
        padding-bottom: 100px;
    }

    .h2desctop {
        font-size: 30px;
        font-family: Manrope Bold;
        color: #231c37;
        margin-top: 1%;
        margin-bottom: 40px;
    }

    .fotokind {
        text-align: center;
        padding-top: 80px;
    }

    .fotokind img {
        max-width: 100%;
    }

    .nameresult {
        font-family: Manrope Bold;
        color: #fff;
        font-size: 24px;
    }

    .textresult {
        padding-top: 80px;
        margin-left: -40px;
    }

    .textresult p {
        color: #fff;
        font-size: 18px;
        margin-top: 20px;
        line-height: 1.5;
        margin-bottom: 25px;
        max-width: 570px
    }

    .center-delimeter-green {
        height: 1px;
        background-color: #87d575;
        margin-top: 35px;
        margin-bottom: 20px;
    }

    .shapka {
        font-size: 16px;
        color: #caffbb;
        font-family: 'Manrope Light';
        height: 24px;
        margin-bottom: 5px;
    }

    .stalo {
        font-size: 22px;
        color: #fff;
        font-family: Manrope Bold;
        margin-bottom: 5px;
    }

    .bilo {
        font-size: 18px;
        color: #caffbb;
        font-family: Manrope Bold;
    }

    @media (max-width: 767px) {
        .firstpage p {
            background: #fff;
        }

        .firstpage h2 {
            background: #ed1c24;
            padding-top: 5px;
            margin-top: 25px;
        }
    }

    @media (max-width: 1199px) {
        .textresult img {
            display: none;
        }
    }

    @media (max-width: 991px) {
        .textresult {
            margin-left: 0px;
        }

        .stalo, .bilo {
            font-size: 16px;
        }

    }

    @media (max-width: 575px) {
        .greenback.container-fluid {
            padding-left: 15px !important;
            padding-right: 15px !important;
        }

        .desktop-vers {
            display: none;
        }

        .mobile-vers {
            display: block;
        }

        .h2desctop {
            color: #fff;
            margin-top: 0px;
            line-height: 1.1;
        }

        .greenback {
            padding-top: 40px;
            margin-top: 25px;
        }

        .fotokind {
            padding: 0px;
        }

        .kray {
            margin-left: -30px;
            margin-right: -30px;
        }

        .nameresult {
            margin-top: 30px;
            margin-bottom: 30px;
        }

        .shapka {
            color: #ffdb00;
            text-shadow: 0px 0px 0px #ffdb00;
        }

        .stalo {
            font-size: 22px;
        }

        .bilo {
            font-size: 18px;
        }

        .fz16px {
            font-size: 16px;
        }

        .mobile-vers p {
            font-size: 18px;
            color: #fff;
            line-height: 1.5;
            margin-top: 5px;
        }
    }

</style>
